import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${rem(18)};
  gap: ${rem(18)};
  border-radius: ${rem(18)};
  background: ${({ theme }) => theme.color.white};
  //box-shadow: 0 6px 16px 2px rgba(0, 0, 0, 0.08);
  box-shadow: 0 3.01887px 12.0755px 1.50943px rgba(0, 0, 0, 0.08);
`;

export const CardImage = styled.img`
  width: 100%;
  border-radius: ${rem(8)};
  object-fit: cover;
`;

export const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: ${rem(8)};
`;

export const CardWrapper = styled.div`
  aspect-ratio: 360 / 227;
  position: relative;
  `